var common = (function ($) {
  "use strict";

  var cookieBar = function cookieBar() {
    var $cookieBarElement = $("#se-cookies-message-container");

    if ($cookieBarElement.length === 0) return;
    $cookieBarElement.removeClass("hide");

    /**
     * Set a cookie for the cookiebar accept
     * @param {string} name
     * @param {string} value
     * @param {date} days
     */
    function SE_setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
    function SE_getCookie(name) {
      var pair = document.cookie.match(new RegExp(name + "=([^;]+)"));
      return !!pair ? pair[1] : null;
    }
    var cookiesName = "cookies_accepted";
    function SE_CheckCookies() {
      if (!SE_getCookie(cookiesName)) {
        var cookies_message = document.getElementById("se-cookies-message");
        cookies_message.className += " se-cookies-message-open";
      }
    }
    function SE_CloseCookiesWindow() {
      SE_setCookie(cookiesName, true, 9999);
      document
        .getElementById("se-cookies-message-container")
        .removeChild(document.getElementById("se-cookies-message"));
    }
    var $acceptBtn = $("#se-accept-cookies-checkbox");

    $acceptBtn.on("click", function (event) {
      if ($(event.target).closest("#se-accept-cookies-checkbox").length) {
        SE_CloseCookiesWindow();
        event.stopPropagation();
      }
    });

    SE_CheckCookies();
  };

  /**
   * Fire events on document ready and bind other events
   *
   * @since   1.0.0
   */
  var ready = function ready() {
    cookieBar();
  };

  /**
   * Only expose the ready function to the world
   */
  return {
    ready: ready,
  };
})(jQuery);

jQuery(common.ready);
window.custom = window.custom || {};

jQuery(function ($) {
  var _this = this;

  /**
   * Helper function to replace data within the grid item
   * @param {selector} element
   */
  custom.swatchImage = function (element, clickedElement) {
    if (element === undefined) return;

    // grab some data
    var getDataImgURL = $(element)
      .closest(".variant-wrapper")
      .find(".color-form--data")
      .data("img");
    var getImageElement = $(element)
      .closest(".grid__item")
      .find(".grid__image-ratio");
    var getFormBtn = $(element).closest(".variants--form").find(".add-to-cart");
    var getBackInStockBtn = $(element)
      .closest(".variants--form")
      .find(".BIS_trigger");
    var getVariantID = $(clickedElement).data("value");
    var getCurrentGridItem = $(clickedElement).closest(".grid__item");
    var getAvailabilityState = $(element)
      .closest(".variant-wrapper")
      .find(".variant-item--handler")
      .data("available");
    var $gridItemElement = $(".grid-product");
    var $gridButtonElement = $(".product-btn");
    var $preloaderPlaceholder = $(element)
      .closest(".variant-wrapper")
      .find(".preloader--placeholder");
    var $getPriceElement = $(element)
      .closest(".grid__item")
      .find(".grid-product__price");
    var getDataVariantPrice = $(element)
      .closest(".variant-wrapper")
      .find(".color-form--data")
      .data("price");
    var $currentDeepLinkElement = $(clickedElement)
      .closest(".grid-product")
      .find(".grid-product__link");
    var getCurrentItemHandle = $(clickedElement)
      .closest(".grid-product")
      .attr("data-handle");

    // pre-load asset
    $preloaderPlaceholder.html(
      '<link rel="preload" as="image" href="' + getDataImgURL + '">'
    );

    // resets
    $gridButtonElement.each(function () {
      if ($(this).hasClass("add-to-cart-native")) return;
      $(this).addClass("hide");
    });
    getFormBtn.prop("disabled", false);
    $gridItemElement.removeClass("grid__item--active");

    // update deep link with proper variant pre-selected
    if (typeof getCurrentItemHandle !== "undefined") {
      var newDeepLinkURL =
        "/products/" + getCurrentItemHandle + "?variant=" + getVariantID;
      $currentDeepLinkElement.attr("href", "");
      $currentDeepLinkElement.attr("href", newDeepLinkURL);
    }

    // check first if it has a handler class
    if (getFormBtn.hasClass("add-to-cart--handler")) {
      // show the add to cart button and activate the input field if available
      if (getAvailabilityState === "sold-out") {
        // update the sold-out variant id in the back in stock helper
        getBackInStockBtn.attr("data-variant-id", getVariantID);
        getBackInStockBtn.removeClass("hide");
      } else {
        if (getFormBtn.hasClass("handler-Personalized")) {
          getFormBtn.replaceWith(
            '<a href="/products/' +
              getCurrentItemHandle +
              "?variant=" +
              getVariantID +
              '" class="btn btn--primary btn-backinstock btn-configure-now">' +
              theme.strings.engravingBtnLinkText +
              "</a>"
          );
        } else {
          getFormBtn.html(theme.strings.addToCartText);
          // bind the click event to the add to cart button
          custom.initAjaxGridItemForm(true, getFormBtn);
          getFormBtn.removeClass("hide");
        }
      }
    } else {
      getFormBtn.removeClass("hide");
    }

    // apply this class for styling effect
    if (getCurrentGridItem.hasClass("grid__item--active") === false) {
      getCurrentGridItem.addClass("grid__item--active");
    }

    // replace the price with the new price
    $getPriceElement.html(getDataVariantPrice);

    // replace the image with the new variant one
    getImageElement.delay(300).queue(function (next) {
      $(this).css("background-image", "url(" + getDataImgURL + ")");
      next();
    });
  };

  /**
   * Initialize the collection product swatcher
   */
  custom.initAjaxGridItemSwatcher = function () {
    var gridItemEl = $(".grid-product");
    if (gridItemEl.length === 0) return;

    var selectors = {
      variantWrapper: ".variant-item--handler",
      colorSwatchLabel: ".color-swatch",
      inputColorData: ".color-form--data",
      variantColorInit: "variant-js-initialized",
      variantsForm: ".variants--form",
    };

    if ($(selectors.variantsForm).length === 0) return;

    // this resets the input form onload
    $(selectors.variantsForm).trigger("reset");

    // loop through all variants
    jQuery.each($(selectors.variantWrapper), function () {
      var colorElement = this;

      // only bind click event if not already attached
      if ($(colorElement).hasClass(selectors.variantColorInit)) return;

      // bind the variant selector click event function
      $(colorElement).on("click", function (event) {
        if ($(event.target).closest(selectors.variantWrapper).length) {
          // execute the heavy lifting to replace stuff onclick
          custom.swatchImage($(this), this);
          $(selectors.colorSwatchLabel).removeClass("active-variant");
          $(this).addClass("active-variant");
          event.stopPropagation();
        }
      });

      // simply add a initialized class to the element so it doesn't get init again on infinite load trigger
      $(colorElement).addClass(selectors.variantColorInit);
    });
  };

  /**
   * Init native add to cart button click (single variant products)
   */
  $(document).on("click", ".add-to-cart-native", (event) => {
    var $this = $(event.target);

    // disable defaults
    event.preventDefault();
    $this.prop("disabled", true);
    $this.addClass("btn--loading");

    // grab the id for the form
    var getFormProductId = $this.data("form");
    var formRaw = $("#quick-form--" + getFormProductId).serialize();
    var getVariantId = formRaw.split("=").pop();

    var formData = {
      items: [
        {
          id: getVariantId,
          quantity: 1,
        },
      ],
    };

    // Post everything to the cart
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(function (response) {
        if (response.status !== 200) {
          // all items are sold out
          alert(theme.strings.maxItemAdded);
          // set btn back to normal
          $this.prop("disabled", false);
          $this.removeClass("btn--loading");
          return;
        }
        // Examine the data in the response
        response.json().then(function (data) {
          //console.log(data);
          // trigger the add to cart event global
          $("body").trigger("added.ajaxProduct", $this);
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: {
                product: data,
              },
            })
          );

          // set btn back to normal
          $this.prop("disabled", false);
          $this.removeClass("btn--loading");
        });
        execC = true;
      })
      .catch(function (error) {
        console.error(error);
        // set btn back to normal
        $this.prop("disabled", false);
        $this.removeClass("btn--loading");
      });
    event.stopPropagation();
  });

  /**
   * Init the add to cart click event for the collection item form
   */
  custom.initAjaxGridItemForm = function (allowClick, addToCartHandler) {
    if (allowClick === false) return;

    if (addToCartHandler.length === 0) return;

    addToCartHandler.unbind("click");
    addToCartHandler.on("click", function (event) {
      if ($(event.target).closest(addToCartHandler).length) {
        var $this = $(this);

        // disable defaults
        event.preventDefault();
        $this.prop("disabled", true);
        $this.addClass("btn--loading");

        // grab the id for the form
        var getFormProductId = $this.data("form");
        var formRaw = $("#quick-form--" + getFormProductId).serialize();
        var getVariantId = formRaw.split("=").pop();

        var formData = {
          items: [
            {
              id: getVariantId,
              quantity: 1,
            },
          ],
        };

        // Post everything to the cart
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then(function (response) {
            if (response.status !== 200) {
              // all items are sold out
              alert(theme.strings.maxItemAdded);
              // set btn back to normal
              $this.prop("disabled", false);
              $this.removeClass("btn--loading");
              return;
            }
            // Examine the data in the response
            response.json().then(function (data) {
              //console.log(data);
              // trigger the add to cart event global
              $("body").trigger("added.ajaxProduct", $this);
              document.dispatchEvent(
                new CustomEvent("ajaxProduct:added", {
                  detail: {
                    product: data,
                  },
                })
              );

              // set btn back to normal
              $this.prop("disabled", false);
              $this.removeClass("btn--loading");
            });
            execC = true;
          })
          .catch(function (error) {
            console.error(error);
            // set btn back to normal
            $this.prop("disabled", false);
            $this.removeClass("btn--loading");
          });
      }
      event.stopPropagation();
    });
  };

  custom.initBackInStockHelper = function () {
    var $templateProduct = $(".template-product");

    if ($templateProduct.length === 0) return;

    // global event triggers
    document.addEventListener("variant:change", function (evt) {
      selectCallback(evt.detail.variant);
    });

    selectCallback = function selectCallback(variant) {
      // your existing selectCallback function code here...

      if (variant && variant.available) {
        $("#BIS_trigger").hide(); // hide the button
        $(".add-to-cart-theme").show();
        $(".express-btns").show();
      } else {
        $("#BIS_trigger").show().attr("data-variant-id", variant.id); // show the button and set the default variant
        $(".add-to-cart-theme").hide();
        $(".express-btns").hide();
      }
    };
  };

  /**
   * Watch for ajaxProduct event
   */
  custom.initItemAddedCallback = function () {};

  /**
   * This will update and execute the default add to cart flow
   * @param {boolean} buildCart
   */
  custom.updateAndOpenCart = function (productObject) {
    var addToCartFeedbackMsg = $(".message--item-added");
    var deliveryDateMsg = $(".message--delivery-date");
    _this.drawer = new theme.Drawers("CartDrawer", "cart");

    //let returnFocusEl = "#CartDrawer";
    _this.drawer.open(true);

    // hide default
    deliveryDateMsg.addClass("hide");
    // show feedback
    addToCartFeedbackMsg.removeClass("hide");
    // reset state
    var setIntervalSuccessMessage = setTimeout(function () {
      addToCartFeedbackMsg.addClass("hide");
      deliveryDateMsg.removeClass("hide");
      clearTimeout(setIntervalSuccessMessage);
    }, 4000);

    // send all infos to the cv tracker
    custom.sendTracking(productObject);
  };

  /**
   * A helper function that will trigger the trackers
   * This function usually gets triggered when the updateAndOpenCart() fires
   * @param {object} product
   */
  custom.sendTracking = function (product) {
    if (product === undefined) return;

    var checkHasKey = product.hasOwnProperty("items");

    var productItem = null;
    var itemQty = 1;

    // check if we have a add to cart from grid item or product page
    if (checkHasKey) {
      productItem = product.items[0];
      itemQty = 1;
    } else {
      // we are on a product page and we need to grab the quantity input value
      productItem = product;
      itemQty = $("#qty-label--" + productItem.product_id)
        .find(".js-qty__num")
        .val();
    }

    // make sure this is set otherwise just exit
    if (checkHasKey === null) return;

    // format cents to float
    var formatMoneyPrice = parseFloat(productItem.price / 100).toFixed(2);

    /**
     * Pinterest Tracking Beacon
     */
    if (typeof pintrk !== "undefined") {
      pintrk("track", "addtocart", {
        value: formatMoneyPrice,
        currency: theme.strings.cartCurrencySymbol,
        order_quantity: itemQty,
        order_id: productItem.title,
        line_items: [
          {
            product_id: productItem.variant_id,
            product_category: productItem.product_type,
          },
        ],
      });
    }

    if (typeof ga !== "undefined") {
      ga("send", { hitType: "pageview", page: "/cart", title: "Add To Cart" });
    }
    // ob tracking
    if (typeof obApi !== "undefined") {
      obApi('track', 'AddToCart');
    }
    // Ktag tracking
    if (typeof ktag !== "undefined") {
      ktag("install", true);
      ktag("AddToCart", true);
    }

    console.log("Custom events fired...");
  };
});

$(document).ready(function () {
  // initialize on dom ready
  custom.initAjaxGridItemSwatcher();
  custom.initBackInStockHelper();
  custom.initItemAddedCallback();

  // triggers when product was added to the cart
  document.addEventListener("ajaxProduct:added", function (evt) {
    custom.updateAndOpenCart(evt.detail.product);
  });
  // triggers when ajaxcart changes
  document.addEventListener("cart:updated", function (evt) {
    // adjust quantity
    var cartCount = evt.detail.cart.item_count;
    var cartCountHtml = "<small>" + cartCount + "</small>";
    $(".cart_count").html(cartCountHtml);
  });
});


   function utmModal_getUTMParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      const results = regex.exec(window.location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
function getTodaysDateInGerman() {
  const today = new Date();
  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  return today.toLocaleDateString('de-DE', options);
}
    const utmModal_showModal = (utmContent) => {
      const modal = document.getElementById('utmModal_myModal');
      const modalText = document.getElementById('utmModal_modal-text');
      modalText.innerHTML = '<h2 style="font-weight:normal">🎉 <b style="background-color:yellow;padding:3px;">15% Rabatt</b> 🎉 exklusiv für <br><b>' + utmContent + '</b><br> Nutzer!</h2>';
      modal.style.display = 'block';
    };

	const utmModal_applyDiscount = () => {
	  const discountCode = 'APPSALE15';
	  const currentUrl = new URL(window.location.href);
	  const newPath = currentUrl.pathname;
	  const baseUrl = currentUrl.origin;
	  const shopifyUrl = baseUrl + '/discount/' + discountCode + '?redirect=' + newPath;
      
	  localStorage.setItem('utmModal_discountApplied', 'true');
      localStorage.setItem('utmModal_discountAppliedTimestamp', new Date().getTime());
     localStorage.setItem('utmModal_discountApplied', 'true');

      if (typeof ktag !== "undefined") {
        ktag("confirmDiscount", true);
      }
	  window.location.href = shopifyUrl;
	};

    const utmModal_closeModal = () => {
      const modal = document.getElementById('utmModal_myModal');
      modal.style.display = 'none';
    };
function updateDiscountMessage() {
  console.log('calling updatedisc message');
  const discountMessageElement = document.getElementById('discount-message');
  const discountApplied = localStorage.getItem('utmModal_discountApplied');
  const discountAppliedTimestamp = localStorage.getItem('utmModal_discountAppliedTimestamp');
  const discountAppName = localStorage.getItem('utmModal_discountAppName');
  const timeSinceDiscountApplied = new Date().getTime() - discountAppliedTimestamp;
  const timeLeft = Math.max(0, 60 - Math.floor(timeSinceDiscountApplied / 1000));
  const timeLeftInMinutes = Math.floor(timeLeft / 60);
  console.log('nearly finihsed');
  if (discountApplied === 'true' && discountAppName != null) {
    discountMessageElement.innerHTML = `<b>15% Gutschein</b> für <b>${discountAppName}</b> Nutzer hinterlegt. Dein Rabatt wird an Kasse abgezogen!`;
    discountMessageElement.style.display = 'block';
  } else {
    discountMessageElement.innerHTML = '';
    discountMessageElement.style.display = 'none';
  }
  console.log('finished');
}
    function utmModal_init() {
      const utmSource = utmModal_getUTMParameter('utm_source');
      const utmContent = utmModal_getUTMParameter('app_name');
      const discountApplied = localStorage.getItem('utmModal_discountApplied');
	  //const discountApplied = false;
      const specificUtmSource = 'dsp';
      updateDiscountMessage();
      
      if (utmSource === specificUtmSource && discountApplied !== 'true') {
        localStorage.setItem('utmModal_discountAppName', utmContent);
        utmModal_showModal(utmContent);
      }

      const redeemBtn = document.getElementById('utmModal_redeem-btn');
      const closeModalLink = document.getElementById('utmModal_close-modal');

      redeemBtn.addEventListener('click', utmModal_applyDiscount);
      closeModalLink.addEventListener('click', () => {
        utmModal_closeModal();
        utmModal_applyDiscount();
      });
    }

    document.addEventListener('DOMContentLoaded', utmModal_init);

